import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import Fragment from 'react-dot-fragment';

import CheckIcon from '../../../../containers/assets/onboarding-check.png';

const Wrapper = styled.div`
  flex: 0 0 268px;
  background: #ffffff;
  padding: 40px 31px 40px 38px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-right: 1px solid #d5d9dd;
  align-self: stretch;
`;

const Step = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);

  img {
    margin-right: 10px;
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const SubSection = styled.div`
  border-left: 1px solid #2da548;
  margin-top: 13px;
  margin-bottom: 13px;
  padding-left: 16px;
  margin-left: 31px;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SubSectionItem = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);

  a:active, a:visited, a:link {
    color: rgba(0, 27, 59, 0.38);
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const Navigation = ({
  data,
  category
}) => {
  return (
    <Wrapper>
      {data.map((link, index) => {
        if (!!link.parent) {
          return null;
        }

        const subLinks = data.filter(i => i.parent === link.title);
        const linkUrl = link.steps.length > 0
          ? link.steps[0].url
          : subLinks.length > 0
            ? subLinks[0].steps[0].url
            : null;
        if (!linkUrl) {
          return null;
        }

        return (
          <Fragment key={`section-${index}`}>
            <Step isActive={true}>
              <img src={CheckIcon} alt="nav icon" />
              {index !== category && (
                <Link to={`${linkUrl}`}>{link.title}</Link>
              )}
              {(index === category) && link.title}
            </Step>

            <SubSection>
              {subLinks.map(subLink => {
                const subLinkIndex = data.findIndex(i => i.title === subLink.title);

                return (
                  <SubSectionItem key={`subsection-${index}-${subLinkIndex}`} isActive={true}>
                    {subLinkIndex !== category && (
                      <Link to={`${subLink.steps[0].url}`}>{subLink.title}</Link>
                    )}
                    {(subLinkIndex === category) && subLink.title}
                  </SubSectionItem>
                );
              })}
            </SubSection>
          </Fragment>
        );
      })}
    </Wrapper>
  );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/navigation.js